export const MISSING_EMAIL_MSG = 'Please type in your email before proceeding.';
export const INVALID_EMAIL_MSG = 'Please correct your email address before proceeding.';
export const UNEXPECTED_ERROR_MSG = 'An unexpected error occurred.';
export const ENTRY_WARNING = 'Incorrect cvc or zip code can cause declined card error.';
export const GENERAL_ERROR_MSG =
  "Please double check you've filled out all your information correctly.";
export const FRAUD_ALERT_MSG =
  'Protect yourself from fraud and scams. Philo will only charge you using a payment method that you entered on the Philo web site or in a Philo app. Know that Philo will never request payments from any other channel.';
